// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var BasicEnrollmentPaymentType;
(function (BasicEnrollmentPaymentType) {
    BasicEnrollmentPaymentType["debitcard"] = "debitcard";
    BasicEnrollmentPaymentType["check"] = "check";
    BasicEnrollmentPaymentType["virtualdebitcard"] = "virtualdebitcard";
    BasicEnrollmentPaymentType["thirdpartyadjudication"] = "thirdpartyadjudication";
    BasicEnrollmentPaymentType["sitecheckforpatient"] = "sitecheckforpatient";
    BasicEnrollmentPaymentType["sitecheckforsite"] = "sitecheckforsite";
    BasicEnrollmentPaymentType["efttosite"] = "efttosite";
    BasicEnrollmentPaymentType["copaycard"] = "copaycard";
})(BasicEnrollmentPaymentType || (BasicEnrollmentPaymentType = {}));
//# sourceMappingURL=basicEnrollmentPaymentType.js.map